module.exports = __webpack_public_path__ + "static/img/voice-assistant.1de844b.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/voice-assistant.png
// module id = W6mu
// module chunks = 1